

import Component from "vue-class-component";
import { InjectReactive } from "vue-property-decorator";
import { $t } from "@/lib/i18nHelpers";
import Original from "@/components/CallController/components/CallNotification/CallNotification.ts";
import { CallPrices } from "@/plugins/paidCalls/components/PaidCallController/PaidCallController.vue";

@Component({ name: "PaidCallNotification" })
export default class PaidCallNotification extends Original {
  @InjectReactive({ from: "callPriceToProvide", default: () => ({ currentCallPrice: 0 }) })
  public readonly callPrices!: CallPrices;

  public get description() {
    const status = this.opponentSubscriptionStatus;
    if (this.callPrices.currentCallPrice > 0) {
      let fromText = status !== "user" ? $t("from your {0}", [$t(status)]) : "";
      return $t("Paid call{0}", [" " + fromText]);
    } else if (status !== "user") return $t("Your {0}", [$t(status)]);
    return "";
  }
}
